import React from "react";
import '../css/styles.css'

export default function HorizontalLine(props) {
    return <hr className="w-auto" style={{color: props.color || '#7C7C7C'}} />
}